import { Navigate, NavigateFunction, To, useNavigate } from 'react-router-dom';
import { useAppointmentHistory } from '../../../context/Appointment/appointment';
import { isElectron } from '../../EnvironmentFlags/EnvironmentFlags';
import { useEffect } from 'react';
import { NavigateAndRecordHook } from './NavigateAndRecord.types';
import { PathName } from '../../Routes';

/**
 * Returns an object of helper functions and controls that use `react-router-dom` `navigate()` and
 * `<Navigate />` bundled with a function to record each page an appointment visits.
 */
export const useNavigateAndRecord: NavigateAndRecordHook = () => {
    const navigate: NavigateFunction = useNavigate();
    const { insertLastPageVisited } = useAppointmentHistory();

    return {
        navigateAndRecord: (to, options = undefined, appointmentKey = undefined) => {
            const [correctedTo, queryParameters] = to.toString()
                .split('?');
            const path: To = appointmentKey !== undefined ?
                `${PathName(correctedTo, appointmentKey)}${queryParameters?.length > 0 ? `?${queryParameters}` : '/'}`
                : to;

            if (!isElectron()) {
                insertLastPageVisited(correctedTo, appointmentKey);
            }

            navigate(path, options);
        },
        NavigateAndRecord: ({
            to,
            replace,
        }) => {
            useEffect(() => {
                if (!isElectron()) {
                    insertLastPageVisited(to.toString());
                }
            });

            return (
                <Navigate
                    to={to}
                    replace={replace}
                />
            );
        },
    };
};